<template>
  <div class="addPrevention">
    <div class="add-content-container">
      <div
        class="add-titieMain"
        style="height: auto"
      >
        <div class="add-title-container">渔肥记录单</div>
        <div
          class="add-content"
          style="height: auto; padding-bottom: 10px"
        >
          <div class="operation-btn">
            <el-button
              size="small"
              class="del"
              @click="onDelete"
              :disabled="enableTable && !form.orderId"
            >删除</el-button>
            <el-button
              size="small"
              class="add"
              @click="initForm"
              :disabled="enableTable || !edit"
            >增加</el-button>
            <el-button
              size="small"
              class="alter"
              @click="onAlter"
              :disabled="enableTable || !edit"
            >修改</el-button>
            <el-button
              size="small"
              class="save"
              @click="onSave"
              :disabled="!enableTable"
              :loading="isLoading"
            >保存</el-button>
            <el-button
              size="small"
              class="cancel"
              @click="onRollBack"
              :disabled="!enableTable"
            >撤销</el-button>
            <el-button
              size="small"
              class="close"
              @click="closeView"
            >关闭</el-button>
          </div>
          <div
            class="custom-search-container"
            style="margin-top: 15px"
            :class="{ 'auto-lock': isAutoOrder }"
            @click="onLockedAreaClick"
          >
            <div class="custom-search-box">
              <div class="custom-search-box-warpper">
                <span>基地</span>
                <el-select
                  v-model="form.fishBaseId"
                  @change="baseChange"
                  :disabled="!!form.orderId"
                  filterable
                  size="small"
                >
                  <el-option
                    v-for="base in baseList"
                    :key="base.key"
                    :label="base.value"
                    :value="base.key"
                  />
                </el-select>
              </div>
              <div class="custom-search-box-warpper">
                <span>日期</span>
                <el-date-picker
                  size="small"
                  v-model="form.dataDate"
                  type="date"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="isAutoOrder"
                  :picker-options="pickerTimeOptions"
                />
              </div>
              <div class="custom-search-box-warpper">
                <span>负责人</span>
                <el-select
                  v-model="form.leaderId"
                  :disabled="!!form.orderId"
                  filterable
                  placeholder="请选择负责人"
                  size="small"
                >
                  <el-option
                    v-for="item in companyUser"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="custom-search-box">
              <div class="pond-batch-group">
                <div class="custom-search-box-warpper">
                  <span>塘口</span>
                  <el-select
                    v-model="form.fishPondId"
                    @change="headPondChange"
                    :disabled="!!form.orderId"
                    filterable
                    size="small"
                  >
                    <el-option
                      v-for="pond in [{ key: '', value: '全部' }, ...pondList]"
                      :key="pond.key"
                      :label="pond.value"
                      :value="pond.key"
                    />
                  </el-select>
                </div>
                <div
                  class="custom-search-box-warpper allow-edit"
                  v-if="form.fishPondId"
                >
                  <span>周期</span>
                  <el-select
                    v-model="form.fishBatchId"
                    class="pond-batch-select"
                    filterable
                    placeholder="请选择"
                    size="small"
                    :disabled="edit == false"
                    @change="headerBatchChange"
                  >
                    <el-option
                      v-for="(item, index) in pondBatchList"
                      :key="index"
                      :label="item.value"
                      :value="item.key"
                    />
                  </el-select>
                </div>
              </div>
              <div class="custom-search-box-warpper">
                <span>用量</span>
                <el-input
                  v-model="form.quantity"
                  size="small"
                  :disabled="isAutoOrder"
                  @input="handleQuantity"
                ></el-input>
              </div>
              <div class="custom-search-box-warpper">
                <span>单据号</span>
                <el-input
                  :value="form.billsNo"
                  disabled
                  size="small"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="table-container"
        :class="{ 'auto-lock': isAutoOrder }"
        @click="onLockedAreaClick"
      >
        <table-ex
          :showIndex="true"
          :enable="enableTable"
        >
          <thead-ex>
            <th-ex v-if="!form.fishPondId">塘口</th-ex>
            <th-ex v-if="!form.fishPondId">周期</th-ex>
            <th-ex>渔肥名称</th-ex>
            <!-- <th-ex>计量单位</th-ex> -->
            <th-ex>渔肥来源</th-ex>
            <th-ex>成本均价</th-ex>
            <th-ex>用量</th-ex>
            <th-ex>用药方式</th-ex>
            <th-ex>用药时间</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex
              v-for="(item, index) in form.details"
              :key="index"
              @selected="selectedRow = item"
            >
              <!-- 塘口 --><td-ex
                v-if="!form.fishPondId"
                v-model="item.fishPondId"
                :editable="!isAutoOrder"
                :list="pondList"
                @selected="handlePond(item)"
                type="cmb"
                display="value"
                take="key"
              ></td-ex>
              <td-ex
                v-if="!form.fishPondId"
                :key="`batch-${index}-${item.fishPondId}`"
                class="allow-edit"
                v-model="item.fishBatchId"
                :editable="edit"
                :list="item.batchList"
                display="value"
                take="key"
                type="cmb"
                @selected="batchChange(item)"
              ></td-ex>
              <!-- 渔肥名称 --><td-ex
                v-model="item.productId"
                :editable="!isAutoOrder"
                :list="productList"
                @selected="handleProduct(item)"
                type="cmb"
                display="name"
                take="id"
              ></td-ex>
              <!-- 计量单位<td-ex v-model="item.unit" type='text'></td-ex> -->
              <!-- 渔肥来源 --><td-ex
                v-model="item.dealerId"
                :editable="!isAutoOrder"
                :list="item.dealerList"
                type="cmb"
                display="dealerName"
                take="dealerId"
              ></td-ex>
              <!-- 成本均价 --><td-ex
                v-model="item.avgPrice"
                type="text"
              ></td-ex>
              <!-- 用量 --><td-ex
                v-model="item.quantity"
                :editable="!isAutoOrder"
                type="number"
              ></td-ex>
              <!-- 用药方式 --><td-ex
                v-model="item.mode"
                :editable="!isAutoOrder"
                :list="wayList"
                type="cmb"
                display="name"
                take="id"
              ></td-ex>
              <!-- 用药时间 --><td-ex
                v-model="item.dataTime"
                :editable="!isAutoOrder"
                :list="dataList"
                type="cmb"
                display="name"
                take="id"
              ></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex
            v-model="form.remark"
            :disabled="isAutoOrder"
            @addRow="addRow"
            @delRow="delRow"
          >
            <td>合计</td>
            <td v-if="!form.fishPondId">--</td>
            <td v-if="!form.fishPondId">--</td>
            <td>--</td>
            <!-- <td>--</td> -->
            <td>--</td>
            <td>--</td>
            <td>{{ quantityTotal }}</td>
            <td>--</td>
            <td>--</td>
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "@/common/MixIn.js";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../../service/storage";

export default {
  mixins: [mixins],
  name: "addManure",
  data () {
    return {
      enableTable: true, // 启用表格
      form: {
        fishBaseId: "",
        fishPondId: "",
        fishBatch: "",
        fishBatchId: "",
        leaderId: "",
        dataDate: "",
        quantity: "",
        billsNo: 0,
        remark: "",
        details: [],
      },
      baseList: [], // 基地列表
      pondList: [], // 塘口列表
      pondBatchList: [], // 当前塘口的全部养殖周期
      companyUser: [], // 负责人列表
      productList: [], // 药品名称列表
      dataList: [], // 用药时间列表
      wayList: [], // 用药方式列表
      // 限制日期
      pickerTimeOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      isLoading: false,
    };
  },
  computed: {
    ...mapState(["loginUser"]),
    // 由渔肥采购单自动生成的单据，仅允许修改周期
    isAutoOrder () {
      return Boolean(this.form && this.form.relevancyId);
    },
    quantityTotal () {
      return this.form.details.reduce((acc, cur) => acc + +cur.quantity, 0);
    },
  },
  async mounted() {
    await this.initPagePermission();
    this.form.orderId = this.$route.query.id;
    this.loadBaseData();
  },
  methods: {
    ...mapActions(modules.base, ["getBaseList"]), // 基地
    ...mapActions(modules.pond, ["getFishPond", "getEditPondData"]), // 塘口
    ...mapActions(modules.user, ["getEmployeesByFishBase"]), // 获取负责人数据
    ...mapActions(modules.dataDict, [
      "setUseMedicineTime",
      "getUseMedicineWay",
    ]), // [用药时间 用药方式]
    ...mapActions(modules.materialPurchase, ["getProductList"]), // 获取药品名称
    ...mapActions(modules.feeding, ["getFeedLeaderData", "getLayPrice"]), // [来源, 成本均价]
    ...mapActions(modules.manure, [
      "addPrevent",
      "updatePrevent",
      "updatePreventBatch",
      "getEditPrevent",
      "delPrevent",
    ]), // [新增, 编辑, 修改周期, 获取详情, 删除]
    ...mapActions(modules.proofing, ["getPondUnclearedBatchNo", "getPondBatchList"]), // 周期批次
    ...mapActions(modules.cultureCycle, ["addFishBatch"]),

    ...mapActions(["delVisitedViews"]),
    async loadBaseData (init) {
      const id = this.form.orderId;
      await this.getBaseFn();
      await this.getProductFn();
      await this.getDataList();
      await this.getWayList();
      if (id && !init) {
        const res = await this.getEditPrevent(id);
        const { fishBaseId } = res;
        await this.getPondList(fishBaseId);
        await this.getEmployeesByFishBaseList(fishBaseId);
        for (let detail of res.details) {
          const { productId } = detail;
          // 来源列表
          const dealerList = await this.getFeedLeaderData({
            productId,
            fishBaseId,
          });
          detail.dealerList = [...dealerList];
          detail.avgPrice = detail.price;
          detail.fishBatch = detail.fishBatchName;
          // 该行塘口对应的全部周期（可修改周期用）
          detail.batchList = detail.fishPondId
            ? await this.loadPondBatchList(detail.fishPondId)
            : [];
          //detail.avgPrice = await this.getLayPrice({ productId, fishBaseId });
        }
        if(res.fishPondId){
          res.fishBatch = res.details[0].fishBatchName;
          res.fishBatchId = res.details[0].fishBatchId;
          this.pondBatchList = await this.loadPondBatchList(res.fishPondId);
        }else{
          res.fishPondId = '';
          this.pondBatchList = [];
        }
        this.form = res;
        console.log(res, "详情");
      } else {
        this.form.fishBaseId = this.baseList[0].key;
        this.form.fishPondId = "";
        await this.getPondList(this.form.fishBaseId);
        await this.getEmployeesByFishBaseList(this.form.fishBaseId);
        this.addRow();
      }
    },
    // 获取塘口下的全部养殖周期
    async loadPondBatchList (pondId) {
      if (!pondId) return [];
      const result = await this.getPondBatchList(pondId);
      return (result || []).map((item) => ({
        key: item.key,
        value: String(item.value),
      }));
    },
    // 表头--切换周期(单塘口)
    headerBatchChange (batchId) {
      let item = this.pondBatchList.find((f) => f.key == batchId);
      this.$set(this.form, "fishBatchId", item ? item.key : "");
      this.$set(this.form, "fishBatch", item ? item.value : "");
      // 单塘口模式下明细共用表头周期
      (this.form.details || []).forEach((f) => {
        f.fishBatchId = batchId;
        f.fishBatch = this.form.fishBatch;
      });
    },
    // 表格--切换周期
    batchChange (row) {
      let item = (row.batchList || []).find((f) => f.key == row.fishBatchId);
      row.fishBatch = item ? item.value : "";
    },
    // 采购单自动生成的单据：点击周期以外的字段时提示
    onLockedAreaClick (e) {
      if (!this.isAutoOrder) return;
      let el = e.target;
      let inField = false;
      let allowEdit = false;
      while (el && el !== document.body) {
        if (el.classList) {
          if (el.classList.contains("allow-edit")) allowEdit = true;
          if (
            el.classList.contains("custom-search-box-warpper") ||
            el.classList.contains("tableUnit") ||
            el.classList.contains("addRow")
          ) {
            inField = true;
          }
        }
        el = el.parentElement;
      }
      if (!inField || allowEdit) return;
      Message.error(
        "由渔肥采购单自动生成的渔肥使用单不允许修改，请直接修改渔肥采购单"
      );
    },
    //保存
    async onSave () {
      // 由渔肥采购单自动生成的单据，仅允许修改周期
      if (this.isAutoOrder) {
        await this.onSaveBatch();
        return;
      }
      const details = this.form.fishPondId
        ? this.form.details.filter((row) => row.productId)
        : this.form.details.filter((row) => row.fishPondId);
      const checkRes = this.checkForm(details);
      if (checkRes) return this.$message.error(checkRes);
      this.isLoading = true;
      this.form.details = details;
      this.form.enterpriseId = this.$store.state.curCompany.id; // 公司id
      this.form.warehouseId = null; // 仓库Id
      this.form.warehouseName = ""; // 仓库名称
      let res;
      if (this.form.orderId) {
        res = await this.updatePrevent(this.form).catch(
          (err) => err.response.data
        );
      } else {
        res = await this.addPrevent(this.form).catch(
          (err) => err.response.data
        );
      }
      this.isLoading = false;
      if (!res.billNo) return this.$message.error(res);
      this.$message.success("保存成功");
      this.form.orderId = res.orderId;
      this.enableTable = false;
    },
    // 采购单自动生成的单据--仅保存周期
    async onSaveBatch () {
      if (!this.form.orderId) {
        Message.error("未找到订单Id，无法保存");
        return;
      }
      let details = (this.form.details || []).filter((f) => f.id);
      if (details.length == 0) {
        Message.error("未找到可保存的明细");
        return;
      }
      if (details.some((f) => !f.fishBatchId)) {
        Message.error("周期必须选择");
        return;
      }
      this.isLoading = true;
      try {
        let res = await this.updatePreventBatch({
          id: this.form.orderId,
          data: details.map((f) => ({
            detailId: f.id,
            fishBatchId: f.fishBatchId,
          })),
        });
        this.$message.success("保存成功");
        this.form.orderId = res.orderId;
        this.enableTable = false;
      } catch (err) {
        this.$message.error(
          err.response ? err.response.data : "保存失败"
        );
      }
      this.isLoading = false;
    },
    checkForm (details) {
      console.log(details, "details");
      if (this.form.fishPondId) {
        if (details.every((row) => !row.productId)) return "不能提交空表单";
      } else {
        if (details.every((row) => !row.fishPondId)) return "不能提交空表单";
      }
      if (details.some((row) => !row.quantity)) return "请输入用量";
      if (details.some((row) => !row.mode)) return "请选择用药方式";
      if (details.some((row) => !row.dataTime)) return "请选择用药时间";

      if (!this.form.dataDate) return "日期必须选择";
      if (!this.form.leaderId) return "负责人必须选择";
      return false;
    },
    // 获取基地列表
    async getBaseFn () {
      this.baseList = await this.getBaseList();
    },
    // 获取塘口列表
    async getPondList (fishBaseId) {
      this.pondList = await this.getFishPond(fishBaseId);
    },
    // 获取用药时间列表
    async getDataList () {
      this.dataList = await this.setUseMedicineTime();
    },
    // 获取用药方式列表
    async getWayList () {
      this.wayList = await this.getUseMedicineWay();
    },
    // 获取物资列表
    async getProductFn () {
      this.productList = await this.getProductList(10004);
    },
    // 获取当前基地下的负责人员工列表
    async getEmployeesByFishBaseList (fishBaseId) {
      this.companyUser = await this.getEmployeesByFishBase(fishBaseId);
    },
    // 改变基地回调
    baseChange (e) {
      this.form.leaderId = "";
      this.form.details = [];
      this.addRow();

      this.getPondList(this.form.fishBaseId);
      this.getEmployeesByFishBaseList(this.form.fishBaseId);
    },
    // 顶部选塘口的回调
    async headPondChange (fishPondId) {
      this.$forceUpdate();

       if (fishPondId > 0) {
        this.pondBatchList = await this.loadPondBatchList(fishPondId);
        let result = await this.getPondUnclearedBatchNo(fishPondId);
        let { data: getEditPondDataResult } = await this.getEditPondData(fishPondId);
        this.form.leaderId = getEditPondDataResult.leaderId;
        if (result) {
          this.$set(this.form, "fishBatch", result.value);
          this.$set(this.form, "fishBatchId", result.key);
        } else {
          try {
            await MessageBox.confirm(
              "当前塘口尚未开启新的养殖周期，是否开启？",
              "提示"
            );
            try {
              await this.addFishBatch({
                fishPondId: fishPondId,
                batch: 0,
                startDate: this.form.date,
              });
              let newBatch = await this.getPondUnclearedBatchNo(fishPondId);
              this.$set(this.form, "fishBatchId", newBatch.key);
              this.$set(this.form, "fishBatch", newBatch.value);
              this.pondBatchList = await this.loadPondBatchList(fishPondId);
            } catch (error) {
              this.form.pond = "";
              this.$Alert.info({
                content: "开启新周期失败",
                duration: 5000,
                status: "error",
              });
              // Message.error("开启新周期失败");
            }
          } catch (error) {
            this.form.pond = "";
          }
        }
      } else {
        this.$set(this.form, "fishBatch", "");
        this.$set(this.form, "fishBatchId", "");
        this.pondBatchList = [];
      }

      const res = await this.getPondUnclearedBatchNo(fishPondId).catch(
        (err) => {
          return { key: "" };
        }
      );
      const { data: pondInfo } = await this.getEditPondData(fishPondId).catch(
        (err) => {
          return { data: { pondArea: "" } };
        }
      );
      this.form.details.forEach((detail) => {
        detail.fishPondId = fishPondId;
        detail.fishBatchId = res.key;
        detail.pondArea = pondInfo.pondArea;
      });
      this.$forceUpdate();
    },
    // 塘口改变回调
    async handlePond (item) {
      const res = await this.getPondUnclearedBatchNo(item.fishPondId);
      const { data: pondInfo } = await this.getEditPondData(item.fishPondId);
      item.fishBatchId = res.key;
      item.pondArea = pondInfo.pondArea;
      this.$set(item, "batchList", await this.loadPondBatchList(item.fishPondId));

      let result = await this.getPondUnclearedBatchNo(item.fishPondId);
      if (result) {
        item.fishBatchId = result.key;
        item.fishBatch = result.value;
      } else {
        try {
          await MessageBox.confirm(
            "此塘口已清塘，是否开启新的养殖周期？",
            "提示"
          );
          try {
            await this.addFishBatch({
              fishPondId: item.fishPondId,
              batch: 0,
              startDate: this.order.dataDate,
            });
            let newBatch = await this.getPondUnclearedBatchNo(item.fishPondId);
            item.fishBatchId = newBatch.key;
            item.fishBatch = newBatch.value;
          } catch (error) {
            item.fishPondId = null;
            this.$Alert.info({
              content: "开启新周期失败",
              duration: 5000,
              status: "error",
            });
            // Message.error("开启新周期失败");
          }
        } catch (error) {
          item.fishPondId = null;
        }
      }
    },
    // 物资改变回调
    async handleProduct (product) {
      const { productId } = product;
      // 来源列表
      const dealerList = await this.getFeedLeaderData({
        productId,
        fishBaseId: this.form.fishBaseId,
      });
      product.dealerList = [...dealerList];
      product.dealerId =
        product.dealerList[0] && product.dealerList[0].dealerId;
      // 计量单位
      product.unit = this.productList.find(
        (item) => item.id === productId
      ).unit;
      // 成本均价
      product.avgPrice = this.productList.find(
        (item) => item.id === productId
      ).purchaseMoney;
    },
    // 总的用量改变回调
    handleQuantity (val) {
      const details = this.form.fishPondId
        ? this.form.details.filter((row) => row.productId)
        : this.form.details.filter((row) => row.fishPondId);
      if (details.length === 0) return;
      details.forEach(
        (item) => (item.quantity = (val / details.length).toFixed(2))
      );
      console.log(details, val);
    },
    // 增加行
    addRow () {
      for (let i = 0; i < 5; i++) {
        this.form.details.push({
          dataTime: "", // 用药时间
          fishBatch:"",
          fishBatchId: null, // 批次Id
          batchList: [], // 该行塘口的全部周期
          mode: "", // 用药方式
          productId: "", // 渔肥Id （商品Id）
          dealerId: "", // 渔肥来源 （供应商Id）
          quantity: "", // 数量
          avgPrice: "", // 成本均价
          dealerList: [], // 来源列表
        });
      }
    },
    // 删除行
    delRow () {
      this.form.details = this.form.details.filter(
        (f) => f != this.selectedRow
      );
    },
    // 初始化表单
    initForm () {
      this.form = {
        fishBaseId: "",
        fishPondId: "",
        fishBatch: "",
        fishBatchId: "",
        leaderId: "",
        dataDate: "",
        quantity: "",
        billsNo: 0,
        remark: "",
        details: [],
      };
      this.pondBatchList = [];
      this.loadBaseData(true);
      this.enableTable = true;
    },
    // 删除
    async onDelete () {
      const confirmResult = await this.$confirm(
        "确认要删除此记录单？",
        "提示",
        { type: "warning" }
      ).catch((err) => err);
      if (confirmResult !== "confirm") return;
      const res = await this.delPrevent(this.form.orderId).catch(
        (err) => err.response.data
      );
      if (res.status !== 200) return this.$message.error(res);
      this.$message.success("删除成功");
      this.initForm();
    },
    // 修改
    onAlter () {
      this.enableTable = true;
    },
    // 撤销
    onRollBack () {
      this.loadBaseData();
      this.enableTable = false;
    },
    // 关闭
    closeView () {
      this.delVisitedViews([
        {
          meta: { affix: false },
          path: this.$route.path,
          title: this.$route.meta.title,
        },
      ]);
      this.$router.replace("/productionControl/manureManagement");
    },
  },
};
</script>
<style>
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}
/* 表头--塘口与周期相邻 */
.pond-batch-group {
  display: flex;
  align-items: center;
}
.pond-batch-group .custom-search-box-warpper + .custom-search-box-warpper {
  margin-left: 20px;
}
/* 表头--周期下拉 */
.custom-search-box-warpper .pond-batch-select,
.custom-search-box-warpper .pond-batch-select .el-input--small {
  width: 130px;
  min-width: 130px;
}
/* 自动生成的单据：禁用控件不吞掉点击，便于点击时弹出提示 */
.auto-lock .el-input__inner:disabled,
.auto-lock .el-input__inner[readonly],
.auto-lock .tableUnit > input {
  pointer-events: none;
}
.auto-lock .custom-search-box-warpper:not(.allow-edit),
.auto-lock .tableUnit:not(.allow-edit) {
  cursor: not-allowed;
}
</style>
